webpackJsonp([35783957827783],{

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _megaphone = __webpack_require__(71);
	
	var _megaphone2 = _interopRequireDefault(_megaphone);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Announcement = function (_Component) {
	  _inherits(Announcement, _Component);
	
	  function Announcement() {
	    _classCallCheck(this, Announcement);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Announcement.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'announcement' },
	      _react2.default.createElement(
	        'div',
	        { className: 'a-icon' },
	        _react2.default.createElement('img', { src: _megaphone2.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'a-info' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Get your copy of ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/hands-on-gatsbyjs' },
	            _react2.default.createElement(
	              'span',
	              null,
	              '"Hands on Gatsbyjs"'
	            )
	          ),
	          ' and learn how to supercharge your websites, embrace JAMStack and add microservices to implement authenticacion, create shopping carts and more.',
	          ' ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/hands-on-gatsbyjs', className: 'a-animation' },
	            'get your copy now'
	          )
	        )
	      )
	    );
	  };
	
	  return Announcement;
	}(_react.Component);
	
	exports.default = Announcement;
	module.exports = exports['default'];

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(73);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Loader = __webpack_require__(75);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Quotes = function (_Component) {
	  _inherits(Quotes, _Component);
	
	  function Quotes(props) {
	    _classCallCheck(this, Quotes);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.componentDidMount = function () {
	      _axios2.default.get('https://wt-566da441a4b59d2631369d6ab2777d69-0.sandbox.auth0-extend.com/randomeQuote').then(function (res) {
	        var data = res.data;
	
	        _this.setState({
	          author: data[0].author,
	          quote: data[0].body,
	          loading: false
	        });
	      }).catch(function (error) {
	        _this.setState({
	          loading: false,
	          error: 'there is an error loading the quote'
	        });
	      });
	    };
	
	    _this.state = {
	      loading: true,
	      error: '',
	      author: '',
	      quote: ''
	    };
	    return _this;
	  }
	
	  Quotes.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.state.loading ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	        'blockquote',
	        null,
	        '"' + this.state.quote + '" - ' + this.state.author
	      )
	    );
	  };
	
	  return Quotes;
	}(_react.Component);
	
	exports.default = Quotes;
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _calendar = __webpack_require__(201);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _tag = __webpack_require__(72);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _view = __webpack_require__(206);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _gatsbyImage = __webpack_require__(91);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Quotes = __webpack_require__(55);
	
	var _Quotes2 = _interopRequireDefault(_Quotes);
	
	var _Announcement = __webpack_require__(54);
	
	var _Announcement2 = _interopRequireDefault(_Announcement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  var posts = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'main-wrapper animated fadeIn' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'thoughts',
	      _react2.default.createElement(
	        'span',
	        { className: 'title-end' },
	        '_'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'subtitle' },
	      'My everyday thoughts are presented here. Case studies and video presentations.'
	    ),
	    _react2.default.createElement(_Quotes2.default, null),
	    _react2.default.createElement(_Announcement2.default, null),
	    _react2.default.createElement(
	      'section',
	      { className: 'blog-listing' },
	      posts.map(function (_ref2) {
	        var post = _ref2.node;
	        var frontmatter = post.frontmatter;
	
	        return _react2.default.createElement(
	          'article',
	          { className: 'post-item', key: frontmatter.title },
	          _react2.default.createElement(
	            'div',
	            { className: 'post-thumbnail' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: frontmatter.path },
	              _react2.default.createElement(_gatsbyImage2.default, {
	                sizes: frontmatter.featuredImage.childImageSharp.sizes,
	                className: 'thumbnail'
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'view-icon' },
	                _react2.default.createElement('img', { src: _view2.default, alt: 'Phanor Coll' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'post-details' },
	            _react2.default.createElement(
	              'header',
	              { className: 'post-detail' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title' },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: frontmatter.path },
	                  frontmatter.title
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'post-excerpt' },
	              frontmatter.excerpt
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'post-date' },
	              _react2.default.createElement(
	                'div',
	                { className: 'date-icon' },
	                _react2.default.createElement('img', { src: _calendar2.default, alt: 'Phanor Coll' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'date' },
	                frontmatter.date
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'post-tags' },
	              _react2.default.createElement(
	                'div',
	                { className: 'post-icon' },
	                _react2.default.createElement('img', { src: _tag2.default, alt: 'Phanor Coll' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'tag-list' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  frontmatter.tags.map(function (tag) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: tag },
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/tags/' + tag, className: 'a-animation' },
	                        tag
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = IndexPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-06ff0323e5dbda4edc5c.js